import { Component } from '@angular/core';
import { CardComponent } from '@components/card/card.component';

import { OrderCompleteInstructionsConsultationBaseComponent } from '../order-complete-instructions-consultation-base/order-complete-instructions-consultation-base.component';

@Component({
  selector: 'app-order-complete-instructions-treatmyuti',
  templateUrl: './order-complete-instructions-treatmyuti.component.html',
  imports: [CardComponent],
})
export class OrderCompleteInstructionsTreatmyutiComponent extends OrderCompleteInstructionsConsultationBaseComponent {
  protected readonly siteName = 'TreatMyUTI.com';
}
